import { render, staticRenderFns } from "./IconBriefcaseSolid.vue?vue&type=template&id=f817b582"
import script from "./IconBriefcaseSolid.vue?vue&type=script&lang=js"
export * from "./IconBriefcaseSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports